// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PublicEmpresasController from "./public_empresas_controller"
application.register("public-empresas", PublicEmpresasController)

import Transaccion__PagoController from "./transaccion/pago_controller"
application.register("transaccion--pago", Transaccion__PagoController)
